import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  messageWrapper: {
    wordBreak: 'break-word',
  },
  iconButtonWrapper: {
    padding: 0,
  },
}));
